/**
 * @generated SignedSource<<81533d10f52d5826c94ba876f72711b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AnalyticsDataTextRow_analyticsData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnalyticsDatumText_analyticsDatum"
    }
  ],
  "type": "AnalyticsDatumInterface",
  "abstractKey": "__isAnalyticsDatumInterface"
};

node.hash = "34f1ea7ce38e3a7ea8fa6150418cda07";

module.exports = node;
